import { GreaseSeperatorPresent, InfiltrationSystemPresent, InfiltrationSystemType, PipesInsulatedStatus, RainWaterTankPresent, SepticTankPresent, WaterBuildingInfoDto, WaterPressureIncreaseSystemPresent, WaterPressureSufficientStatus, WaterSoftenerStatus } from "shared/types/water-info";

export const calculateWaterBuildingInfoStatus = (waterBuildingInfo: WaterBuildingInfoDto) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    // Water Softener Status
    if ([WaterSoftenerStatus.OK, WaterSoftenerStatus.NOT_REQUIRED].includes(waterBuildingInfo.waterSoftenerStatus)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Waterontharder OK/Niet vereist");
    } else if (waterBuildingInfo.waterSoftenerStatus === WaterSoftenerStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Waterontharder Niet OK");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Waterontharder Onbekend");
    }

    // Infiltration System Present
    if ([InfiltrationSystemPresent.OK, InfiltrationSystemPresent.NOT_REQUIRED].includes(waterBuildingInfo.infiltrationSystemPresent)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Infiltratiesysteem OK/Niet vereist");
        if (waterBuildingInfo.infiltrationSystemPresent === InfiltrationSystemPresent.OK &&
            [InfiltrationSystemType.UNKNOWN, null].includes(waterBuildingInfo.infiltrationSystemType)) {
            dotValues.transparent.count++;
            dotValues.transparent.labels.push("Infiltratiesysteem type onbekend");
        }
    } else if (waterBuildingInfo.infiltrationSystemPresent === InfiltrationSystemPresent.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Infiltratiesysteem Niet OK");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Infiltratiesysteem Onbekend");
    }

    // Septic Tank Present
    if ([SepticTankPresent.OK, SepticTankPresent.NOT_REQUIRED].includes(waterBuildingInfo.septicTankPresent)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Septische tank OK/Niet vereist");
    } else if (waterBuildingInfo.septicTankPresent === SepticTankPresent.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Septische tank Niet OK");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Septische tank Onbekend");
    }

    // Rain Water Tank Present
    if ([RainWaterTankPresent.OK, RainWaterTankPresent.NOT_REQUIRED].includes(waterBuildingInfo.rainWaterTankPresent)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Regenwatertank OK/Niet vereist");
    } else if (waterBuildingInfo.rainWaterTankPresent === RainWaterTankPresent.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Regenwatertank Niet OK");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Regenwatertank Onbekend");
    }

    // Grease Separator Present
    if ([GreaseSeperatorPresent.OK, GreaseSeperatorPresent.NOT_REQUIRED].includes(waterBuildingInfo.greaseSeparatorPresent)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Vetvanger OK/Niet vereist");
    } else if (waterBuildingInfo.greaseSeparatorPresent === GreaseSeperatorPresent.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Vetvanger Niet OK");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Vetvanger Onbekend");
    }

    // Water Pressure Sufficient Status
    if (waterBuildingInfo.waterPressureSufficientStatus === WaterPressureSufficientStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Voldoende waterdruk");
    } else if (waterBuildingInfo.waterPressureSufficientStatus === WaterPressureSufficientStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Onvoldoende waterdruk");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Waterdruk status Onbekend");
    }

    // Pipes Insulated Status
    if (waterBuildingInfo.pipesInsulatedStatus === PipesInsulatedStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Leidingen geïsoleerd");
    } else if (waterBuildingInfo.pipesInsulatedStatus === PipesInsulatedStatus.NOT_OK) {
        dotValues.orange.count++;
        dotValues.orange.labels.push("Leidingen niet geïsoleerd");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Isolatie leidingen Onbekend");
    }

    // Water Pressure System Status
    if (waterBuildingInfo.waterPressureIncreaseSystemPresent === WaterPressureIncreaseSystemPresent.OK || waterBuildingInfo.waterPressureIncreaseSystemPresent === WaterPressureIncreaseSystemPresent.NOT_REQUIRED) {
        dotValues.green.count++;
        dotValues.green.labels.push("Waterdrukverhogingsysteem aanwezig");
    } else if (waterBuildingInfo.waterPressureIncreaseSystemPresent === WaterPressureIncreaseSystemPresent.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Waterdrukverhogingsysteem nodig, maar niet aanwezig");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Waterdrukverhogingsysteem onbekend");
    }

    // Additional fields check
    // ...

    return dotValues;
};
